import { CurrencyMapping } from './CurrencyMapping';

export class CurrencyMappings {
  bitfinex: CurrencyMapping;

  constructor() {
    this.bitfinex = new CurrencyMapping();
  }
}
